/**
 * Creates URL parameters from a given request object.
 *
 * @param request - The request object containing key-value pairs.
 * @returns The URL parameters as a string or null if the request is falsy.
 */
export const createURLParams = <T extends Record<string, unknown>>(
  request: T,
): null | string | undefined => {
  if (!request) return

  const params = new URLSearchParams()

  Object.entries(request).forEach(([key, value]) => {
    if (value) {
      params.set(key, value.toString())
    }
  })

  return params.toString()
}
